import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppNoInfo } from '@/layout/AppComponents';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';
import CalendarNewEventForm from './CalendarNewEventForm';
import _ from 'lodash';

export default function CalendarNewEvent(props) {
  const {
    plantObligationID,
    onCreated,
    isExternal = false,
  } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const calendarDates = useSelector((s) => s.currentPage?.calendarTabs?.[plantObligationID]);

  // < ADD EVENT
  const handleAddCalendarDate = async (values) => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_calendar_add"),
        {
          ...values,
          moduleBridgeHex,
          plantHex,
          plantObligationID,
        }
      );
      dispatch(currentPageAction.change('calendarTabs', { [plantObligationID]: response.data }));
      onCreated(false);
    } catch (err) {}
  };
  // > ADD EVENT

  if (!calendarDates && !isExternal) return <AppNoInfo minHeight={300} />;

  return (
    <CalendarNewEventForm
      plantObligationID={plantObligationID}
      handleAddCalendarDate={(v) => handleAddCalendarDate(v)}
      isExternal={isExternal}
    />
  );
}
